import { css } from "@linaria/core";
import cx from "classnames";

import React from "react";
import { LeftOptions, OptionsWrapper, RightOptions } from "@ui/Highcharts/ui/Card";
import { Divider } from "@ui/Highcharts/ui/Tooltip";
import { colors, spacings } from "@ui/Theme";

import { HIDE_ON_WIDGET_EXPORT } from "@ui/ExportWidgetButton";
import { DisplayFiltersSelect } from "./DisplayFiltersSelect";

import DisplayFiltersToggleButton from "./DisplayFiltersSelect/DisplayFiltersToggle";
import { useDisplayFilterPreferences } from "./useDisplayFilterPreferences";

interface P {
  chartOptions: React.ReactNode;
  periodSettings?: React.ReactNode;
  visibilitySettings?: React.ReactNode;
  actionMenu?: React.ReactNode;
  projectIdToFilter: string;
  allAnalysesMode: boolean;
}

const EvolutionSubHeader = ({
  chartOptions,
  periodSettings,
  visibilitySettings,
  actionMenu,
  projectIdToFilter,
  allAnalysesMode,
}: P) => {
  const { isFiltersSelectionVisible } = useDisplayFilterPreferences(projectIdToFilter);
  return (
    <div className={wrapperFilter}>
      <OptionsWrapper>
        <LeftOptions>
          {chartOptions}
          <div className={HIDE_ON_WIDGET_EXPORT}>
            <DisplayFiltersToggleButton disabled={allAnalysesMode} projectId={projectIdToFilter} />
          </div>
        </LeftOptions>
        {(periodSettings || visibilitySettings) && (
          <RightOptions>
            <div className={cx(containerRightOptions, HIDE_ON_WIDGET_EXPORT)}>
              {periodSettings}
              {visibilitySettings}
            </div>
          </RightOptions>
        )}
      </OptionsWrapper>
      {projectIdToFilter !== undefined && isFiltersSelectionVisible && !allAnalysesMode && (
        <div className={displayFilterWrapper}>
          <DisplayFiltersSelect projectId={projectIdToFilter} />
        </div>
      )}
      <Divider className={divider} />

      {actionMenu}
    </div>
  );
};

export default EvolutionSubHeader;

const wrapperFilter = css`
  width: 100%;
`;

const displayFilterWrapper = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacings.xs};
  margin-top: ${spacings.m};
`;

const divider = css`
  margin: ${spacings.m} 0;
  height: 1px;
  background-color: ${colors.titanium100};
`;

const containerRightOptions = css`
  display: flex;
  align-items: center;
  gap: ${spacings.xs};
`;
